<template>
  <q-dialog
    :visible="isVisible"
    :title="title"
    width="600px"
    :innerScroll="false"
    @close="onCancel"
    :loading="loadingBth"
    @cancel="onCancel"
    @confirm="onConfirm"
  >
    <el-form ref="addForm" :model="addForm" :rules="rules" label-width="100px" size="mini" v-loading="loading">
      <el-form-item label="国补类型:" prop="stateSubsidiesName">
        <el-input v-model.trim="addForm.stateSubsidiesName"></el-input>
      </el-form-item>
      <el-form-item label="适用店铺:" prop="codes">
        <el-select v-model="addForm.codes" filterable multiple clearable collapse-tags>
          <el-option v-for="item in storeList" :label="item.name" :value="item.code" :key="item.code" />
        </el-select>
      </el-form-item>
      <el-form-item label="适用店铺:" prop="store">
        <span>配置适用店铺后，即表示选中店铺的所有订单都为配置的“国补类型”不选择店铺，则表示新增此国补类型，但无默认适用店铺;</span>
      </el-form-item>
    </el-form>
  </q-dialog>
</template>

<script>
export default {
  name: 'CRUDEdit',
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    rowData: Object,
    storeList: Array,
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
    title() {
      return !this.rowData ? '新增' : '编辑' + '国补类型';
    },
  },
  data() {
    return {
      loading: false,
      loadingBth: false,
      addForm: {
        stateSubsidiesName: '',
        codes: [],
      },
      rules: {
        stateSubsidiesName: [
          { required: true, message: '不能为空', trigger: 'blur' },
        ],
      },
    };
  },
  created() {
    if (this.rowData) {
      this.$set(this.addForm, 'stateSubsidiesCode', this.rowData.stateSubsidiesCode)
      this.$set(this.addForm, 'stateSubsidiesName', this.rowData.stateSubsidiesName)
      let code = this.rowData.storeName ? this.storeList.filter((v) => this.rowData.storeName.includes(v.name)).map((v) => v.code) : [];
      this.$set(this.addForm, 'codes', code)
    }
  },
  methods: {
    onCancel() {
      this.isVisible = false;
    },
    onConfirm() {
      this.$refs.addForm.validate((valid) => {
        if (!valid) return;
        this.loadingBth = true;
        this.$q.configurationCenter
          .stateSubsidiesSave({ data: this.addForm })
          .then((res) => {
            if (res.success) {
              let text = '编辑成功';
              this.$message.success(text);
              this.isVisible = false;
              this.$emit('success');
            }
          })
          .finally((_) => {
            this.loadingBth = false;
          });
      });
    },
    async init() {},
  },
};
</script>

<style lang="stylus" scoped>
>>> .el-input--small .el-input__inner, >>> .el-date-editor.el-input, >>> .el-date-editor.el-input__inner
  width 250px !important
>>> .el-input
  width 250px !important
>>> .el-select__tags-text {
  display: inline-block;
  max-width: 60px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
>>> .el-tag__close.el-icon-close {
  top: 0px;
  right: -4px
}
</style>
